import React, { useState, useEffect } from "react"
import Color from "../../constants/Color"

import { Container } from "./styles/rating"
import { Icon } from "../../components"

export default function Rating({ rate, count, rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor(Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor(Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }

    // eslint-disable-next-line
  }, [number])

  return (
    <Container {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{parseFloat(rate).toFixed(1) || parseFloat(count).toFixed(1)}</p>
    </Container>
  )
}
